<div class="flexbox is-pointer py-1 is-align-items-center">
  <img
    *ngIf="transaction?.fromUserUsername && !transaction?.details?.includes('Commissions')"
    class="avatar mr-1"
    [src]="userProfileImageUrl || 'assets/images/featured-cover-art.png'"
  />
  {{ displayName }}
</div>
